var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoInbox24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_inbox24x24",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46759",
    "data-name": "Path 46759",
    d: "M15.6,1.978,14.364.484A1.352,1.352,0,0,0,13.333,0H2.667A1.336,1.336,0,0,0,1.64.484L.409,1.978A1.761,1.761,0,0,0,0,3.111V14.222A1.777,1.777,0,0,0,1.778,16H14.222A1.777,1.777,0,0,0,16,14.222V3.111a1.782,1.782,0,0,0-.4-1.133ZM8,12.889,3.111,8H6.222V6.222H9.778V8h3.111ZM1.889,1.778,2.613.889H13.28l.831.889Z",
    transform: "translate(3 2)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoInbox24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_inbox24x24.dff0ff81a9db34ca1f152dc0a59c003c.svg";